import React from "react";
import { Link } from "react-router-dom";
import { Tile } from "discover.medical.react-component-library";
import { TileContainer, TileListItem } from "./_.styled";
import { SEARCH_PATH_PREFIX } from "../../config";
import { PageDescription, PageTitle } from "../../components";

const TileTemplate = ({
  title,
  description,
  browsePath,
  cdhTopicHierarchy,
  cdh,
  options = {},
}) => {
  const hasSubPages = options.hasSubPages || false;
  const getDestination = (label) => {
    // if we have sub pages, navigate to them when a tile is clicked
    if (hasSubPages) {
      return `/browse/${browsePath}/${label
        .toLowerCase()
        .replace(/,/g, "")
        .replace(/\s/g, "-")
        .replace(/&/g, "and")}`;
    }

    // no sub pages, navigate to search results page when a tile is clicked
    return `${SEARCH_PATH_PREFIX}${cdhTopicHierarchy}|${label}`;
  };

  return (
    <>
      <PageTitle>{title}</PageTitle>
      <PageDescription>{description}</PageDescription>
      <TileContainer>
        {cdh &&
          cdh.map((el) => (
            <TileListItem key={el.label}>
              <Tile
                title={el.label}
                to={encodeURI(getDestination(el.label))}
                linkComponent={Link}
              />
            </TileListItem>
          ))}
      </TileContainer>
    </>
  );
};

export default TileTemplate;
